export default __webpack_public_path__ + "static/media/how-to-invest.0a51cbaa.svg";